export const ASSETS_APP_KEY = 'ASSETS';
export const TENANTLESS_ORG_ID = 'tenantless';
